import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import classes from '../styles/NewTable.module.css';

export type ToggleSwitchProps = PropsWithChildren<{
  id?: string;
  checked?: boolean;
  onChange?: () => void;
  style?: React.CSSProperties;
  disabled?: boolean;
}>;

const ToggleSwitch: FC<ToggleSwitchProps> = ({
  id,
  checked = false,
  onChange,
  style,
  disabled = false,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    
    if (!e.isTrusted) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <div className={`${classes.toggleContainer} ${disabled ? classes.disabled : ''}`}>
      <label className='switch' style={style} onClick={handleClick}>
        <input 
          id={id} 
          checked={checked} 
          onChange={!disabled ? onChange : undefined}
          type='checkbox' 
          className='checkbox' 
          name='active'
          data-testid="patient-status-toggle"
          disabled={disabled}
        />
        <span className='slider round' />
      </label>
    </div>
  );
};

export default ToggleSwitch;
